module.exports = __webpack_public_path__ + "static/media/IconTemplates_-92.28bf3e18.svg";